import actionCreatorFactory from 'typescript-fsa';
import { Folders } from '@visikon/core-models';
// import { IAuthRequest, IAuthToken, IAuthError } from "reducers/authReducer";

const actionCreator = actionCreatorFactory('Folders');

export const listFolders = actionCreator<{ id?: string }>('LIST_FOLDERS');
export const listFoldersSuccess = actionCreator<Folders.FolderTree>('LIST_FOLDERS_SUCCESS');
export const listFoldersError = actionCreator<{ msg: string }>('LIST_FOLDERS_ERROR');
